<template>
  <div>
    <div class="modal-header">
      <h2>Upozorenje</h2>
    </div>
    <div class="modal-body">
      <p>Da li ste sigurni da želite da obrišete tiket: {{ ticket.title }}?</p>
    </div>
    <hr />
    <div class="footer">
      <button
        type="submit"
        class="btn btn-default btn--mod close-btn"
        @click="closeModal"
      >
        Otkaži
      </button>
      <button
        type="submit"
        class="btn btn-danger btn--mod"
        @click="deleteTicket"
        :disabled="loading"
      >
        <p v-if="!loading">Obriši</p>
        <spinner :size="20" line-fg-color="#610d0d" v-if="loading" />
      </button>
    </div>
  </div>
</template>

<script>
import axios from '@/axios/axios.js';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
  created() {},
  computed: {
    ...mapState('modal', ['modalVisible', 'ticket'])
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    ...mapMutations('modal', ['closeModal', 'showModal']),
    ...mapActions('table', ['getTicketsByCommunity', 'getAllTickets']),
    ...mapActions('modal', [
      'showSuccessModal',
      'showFailModal',
      'removeVirtualMemberList'
    ]),

    ...mapActions('table', []),
    async deleteTicket() {
      if (this.loading) {
        return;
      }

      this.loading = true;
      try {
        await axios.post(`/tickets/${this.ticket.id}/delete`, {
          member_id: this.$store.getters.getActiveCommunity.member_id
        });
        if (this.$router.history.current.name === 'communityTickets') {
          this.getTicketsByCommunity({
            memberId: this.$store.getters.getActiveCommunity.member_id,
            communityId: this.$store.getters.getActiveCommunity.id
          });
        } else if (this.$router.history.current.name !== 'ticketDetails') {
          this.getAllTickets();
        }

        this.loading = false;
        this.closeModal();
        this.showSuccessModal();
      } catch (error) {
        console.log(error);
        this.showFailModal();
      }
    }
  }
};
</script>

<style scoped>
.close-btn {
  margin-right: 4px;
}

.btn--mod {
  height: 35px;
  min-width: 75px;
  margin-left: 5px;
  align-self: center;
}
</style>
